<template>
  <div class="input-container" :style="{ margin: margin, height: height }">
    <label :class="{ labelObrigatorio: (isDirty && !isDocumentoValido) || (campoVazio && required && showValidations) }"> {{ label }}</label>
    <div v-if="temIcon" class="field">
      <p class="control has-icons-right">
        <input
          class="input"
          pattern="\d*.\d*.\d*-\d{2}|\d*.\d*.\d*/\d*-\d{2}"
          :id="id"
          type="text"
          :required="required"
          :placeholder="placeholder"
          :value="modelValue"
          @input="$event => setValue($event)"
          :maxlength="maxLength"
          ref="inputDocumento"
          :mensagemCampoObrigatorio="mensagemCampoObrigatorio"
          @blur="validarDocumento"
        />
        <span class="icon is-small is-right">
          <i class="mdi" :class="classIcon"></i>
        </span>
      </p>
    </div>

    <input
      v-else
      class="input"
      type="text"
      :placeholder="placeholder"
      :id="id"
      :maxlength="maxLength"
      :required="required"
      @keyup="this.verificarSeInputEstaVazio(false)"
      pattern="\d*.\d*.\d*-\d{2}|\d*.\d*.\d*/\d*-\d{2}"
      :class="{ inValida: (isDirty && !isDocumentoValido) || (campoVazio && required && showValidations)}"
      :value="modelValue"
      :disabled="isDisabled"
      @input="$event => setValue($event)"
      ref="inputDocumento"
      :mensagemCampoObrigatorio="mensagemCampoObrigatorio"
      @blur="validarDocumento"
    />

    <span v-if="tipLabel" class="tip-label is-size-7">{{ tipLabel }}</span>

    <div class="mensagemDeErro" v-if="showValidations">
      <span v-if="!isDocumentoValido && isDirty" class="campo-obrigatório">
        Insira um número do {{ label? label : defaultLabel }} válido.
      </span>

      <span v-else-if="mensagemCampoObrigatorio && campoVazio && required" class="campo-obrigatório">
        {{ mensagemCampoObrigatorio }}
      </span>

      <span v-else-if="campoVazio && required" class="campo-obrigatório">
        {{ label? label : defaultLabel }} é obrigatório.
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrfDocumentoInput",
  props: {
    label: String,
    aceitaCPF: {
      type: Boolean,
      default: true
    },
    aceitaCNPJ: {
      type: Boolean,
      default: true
    },
    placeholder: String,
    margin: String,
    height: String,
    temIcon: Boolean,
    classIcon: String,
    modelValue: String,
    required: {
      type: Boolean,
      default: true
    },
    id: String,
    tipLabel: String,
    isDisabled: {
      type: Boolean,
      default: false
    },
    mensagemCampoObrigatorio: String
  },
  data() {
    return {
      campoVazio: false,
      isDocumentoValido: false,
      showValidations: false,
      isDirty: false
    };
  },
  computed: {
    maxLength() {
      if (this.aceitaCNPJ) {
        return 18;
      }
      return 14;
    },
    defaultLabel() {
      if (this.aceitaCPF && this.aceitaCNPJ) {
        return "CPF ou CNPJ";
      }
      if (this.aceitaCPF) {
        return "CPF";
      }
      if (this.aceitaCNPJ) {
        return "CNPJ";
      }
      return "Documento";
    }
  },
  methods: {
    async setValue(event) {
      this.isDirty = true;
      const inputValue = event.target.value;
      const onlyNumbers = inputValue.replace(/\D/g, '')
      const valorFormatado = this.aplicarMascara(onlyNumbers)
      event.target.value = valorFormatado
      
      this.$emit('update:modelValue', valorFormatado)

      await this.$nextTick()
      this.isDocumentoValido = !this.$refs.inputDocumento.validity.patternMismatch
    },
    aplicarMascara(value) {
      if (!value) return '';
      value = value.replace(/\D/g,'');
      if (value.length < 12 && this.aceitaCPF) {
        return this.aplicaMascaraCPF(value);
      }

      if (value.length > 11 && this.aceitaCNPJ) {
        return this.aplicaMascaraCNPJ(value);
      }

      return value
    },
    aplicaMascaraCPF(value) {
      value = value.replace(/(\d{3})(\d)/,"$1.$2");
      value = value.replace(/(\d{3})(\d)/,"$1.$2");
      value = value.replace(/(\d{3})(\d{1,2})$/,"$1-$2");
      return value;
    },
    aplicaMascaraCNPJ(value) {
      value = value.replace(/^(\d{2})(\d)/,"$1.$2");
      value = value.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3");
      value = value.replace(/\.(\d{3})(\d)/,".$1/$2");
      value = value.replace(/(\d{4})(\d)/,"$1-$2");
      return value;
    },
    verificarSeInputEstaVazio(isInterno) {
      if (!isInterno) {
        this.showValidations = true
      }
      this.campoVazio = !this.modelValue || this.modelValue.trim() == "";
      this.verificarSeInputEValido()
      return this.campoVazio;
    },
    verificarSeInputEValido() {
      this.isDocumentoValido = !this.$refs.inputDocumento.validity.patternMismatch
      return this.isDocumentoValido
    },
    
    limparValidacao() {
      this.campoVazio = false;
      this.showValidations = false;
      this.isDocumentoValido = true;
      this.isDirty = false;
    },
    
    limparInput() {
      this.$emit('update:modelValue', '')
    },
    
    validarDocumento(e) {
      let documento = e.target.value;
      if(!documento) return;
      this.verificarSeInputEstaVazio(false);
    }
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}
.inValida {
  border: 1px solid #a94442;
}
.mensagemDeErro {
  margin: 0 0 1% 0;
  color: #a94442;
  font-size: 12px;
}
.labelObrigatorio {
  color: #a94442;
}
.tip-label {
  color: #4a4a4a;
  vertical-align: top;
}
</style>
